import React, { useState } from 'react';
import '../StyleSheets/PolicyChronicles.css';

import SeverityBarChart from './SeverityBarChart';
import FilterSelect from './FilterSelect';
import GraphDataItem from './GraphDataItem';
import DropDown from './DropDown';

import gsap from 'gsap';
import LineChart from './LineChart';

export default class PolicyChronicles extends React.Component {
    
    constructor(props) {
        super(props);

        this.chroniclesContRef = React.createRef();

        this.updateEventTypes = this.updateEventTypes.bind(this);

        this.initActiveEvents = [];

        const eventList = props.appSettings.policyEventsKeys.map( (e,i) => {
            this.initActiveEvents.push( i < 3);
            return {
                key: e,
                title: props.coronaData.hebrew_legend[e].title
            }
        });
        
        const curEvents = this.initActiveEvents.map( (e,i) => {

            if(e) { return eventList[i].key; }
            else { return false; }
        });

        const countries = Object.keys( props.coronaData.data ).map( c => {return {key:c,title:c} } )
            .sort( (a,b) => {if(a.key==="ישראל") return -1; else return 1;});

        this.state = {
            
            countries: countries,
            currentCountry: countries[0].key,
            allEventsList: eventList,
            currentEventsTypes: curEvents,
        }
        
        
    }

    updateEventTypes( list ) {
        
        const curentEvent = [];

        for( let i=0; i<list.length; i++) {
            if( list[ i ] ) {

                curentEvent.push( this.state.allEventsList[i].key );
            }
        }

        this.setState( {currentEventsTypes: curentEvent} )
    }

    componentDidMount() {

        gsap.from(this.chroniclesContRef.current, {y:200, opacity:0, duration: 0.8, ease:"power3.out"});

    }

    render() {
        const { appSettings, coronaData } = this.props;
        const { 
            countries,
            currentCountry, 
            currentEventsTypes, 
            allEventsList,
        } = this.state;

        const policyEvents = [];

        const countryData = this.props.coronaData.data[currentCountry];

        currentEventsTypes.forEach( et => {
            const events = countryData[ et ];
            
            if( events === undefined ) return;
                                    
            events.forEach( e => {
                if( e.text === undefined ) return;
                const eObj = Object.assign( {}, e );
                eObj.date = new Date( eObj.d );
                policyEvents.push( eObj );

            })
        })

        policyEvents.sort( (a,b) => {
            if( a.date < b.date ) return 1;
            else return -1;
        });

        return (
            <div id="policyChroniclesCont" ref={this.chroniclesContRef}>

                <section id="policySeverityChart">

                    <h1 className="generalPanelTitle" style={{color:"#ffffff88"}}>חומרת מדיניות לאורך זמן</h1>

                    {/* <DropDown 
                        position={{t:"100px", r: "36px"}}
                        options={countries} 
                        value={currentCountry} 
                        onChange={ e => { this.setState({currentCountry: e.target.value}); }}
                        icon={"public"}
                    /> */}

                    <select id="chroniclesCountrySelect" 
                        value={currentCountry} 
                        style={{top: "100px", right:"36px"}}
                        onChange={ e => { this.setState({currentCountry: e.target.value}); }}>
                            {countries.map( (opt,i) => {
                                return <option key={i + "_" + opt.key} value = {opt.key}>{opt.title}</option> 
                            } )}
                    </select>

                    <FilterSelect 
                        title="סינון קטגוריות מדיניות"
                        theme="light" 
                        list={ allEventsList } 
                        position={{t: '100px', r: '240px'}}
                        activeItems={this.initActiveEvents}
                        bgColor="#222230"
                        onItemSelect={ this.updateEventTypes }
                    />

                    <SeverityBarChart data={{
                        country: currentCountry,
                        colors: appSettings.colors.slice( 4 ),
                        eventsTypes: currentEventsTypes,
                        coronaData: coronaData
                    }}/>

                </section>
                <PolicyLog policyEvents={policyEvents}/>

                <PolicySeverityMultipleCountries appSettings={appSettings} coronaData={coronaData} countries={countries}/>
            </div>
        )

    }

}

function PolicyLog(props) {
    const { policyEvents } = props;

    return  (
        <section id="policyLogCont">
            <h1 className="generalPanelTitle">פירוט אירועי מדיניות</h1>
            <div id="policyChroniclesTextCont">
                { policyEvents.map( (pe,i) => {
                    return <div className="chroniclesPolicyEventItem" key={"pctc"+i}>
                        <div style={{display: "flex", alignItems:"center", justifyContent: "space-between", marginTop:"16px"}}>
                            <p style={{color: "#aeaeae", margin: "0px"}}>{pe.date.toLocaleDateString("he-IL")}</p>
                            <div style={{
                                padding:"2px 8px", 
                                backgroundColor: global.getSeverityColor(pe.v),
                                borderRadius: "6px",
                                maxWidth: "30px",
                                textAlign: "center",
                                marginLeft: "10px",
                                }}>{pe.v}</div>
                        </div>
                        <p style={{marginLeft: "10px"}}>{pe.text}</p>
                    </div>
                })}
            </div>
        </section>
    )

}

function PolicySeverityMultipleCountries(props) {

    const { countries, coronaData, appSettings } = props;

    const[activeCountries,setActiveCountries] = useState( [true,false,true,true] );
    const[currentPolicyCategory,setPolicyCategory] = useState( appSettings.policyEventsKeys[0] );
    
    const countriesToShow= [];
    for(let i=0;i<countries.length;i++) {

        countriesToShow.push({name: countries[i].title, isActive: activeCountries[i]} );
        
    }

    const policyEventOptions = appSettings.policyEventsKeys.map( p => { return {key: p, title: coronaData.hebrew_legend[ p ].title } } );

    function updateShowIndex( inx, isActive ) {
        
        const newActiveCountries = []

        for(let i=0;i<Math.max(activeCountries.length, inx + 1);i++) {
            if(i === inx) {
                newActiveCountries[i] = isActive
            } else {
                newActiveCountries[i] = activeCountries[ i ]
            }
        }

        setActiveCountries( newActiveCountries );

    }

    return (

        <section id="policySeverityMultipleCountriesCont">

            <h1 className="generalPanelTitle" style={{color:"#00000088"}}>השוואת חומרת מדיניות בין מדינות</h1>
            <DropDown key={"policyEventOptionsSelect"} 
                    position={{r: "300px", t:"24px"}}
                    options={policyEventOptions} 
                    value={currentPolicyCategory} 
                    onChange={ e => { setPolicyCategory( e.target.value ); }}
                    icon={"timeline"}
                />
            <div key="graphDataItemsContainer" id="graphDataItemsContainer">
                { 
                    countries.map((_,i) => 
                        <GraphDataItem 
                            key={i+_.key} 
                            title={_.title} 
                            color={ appSettings.colors[4 + i]} 
                            isActive={ activeCountries[ i ] } 
                            onToggle={ a=>{updateShowIndex(i, a)}}
                        />
                    )
                }
            </div>
            <LineChart  
                useToolTips = {false}
                data={{
                    countries: countriesToShow,
                    color: appSettings.colors.slice( 4 ),
                    severityGradient: appSettings.severityGradient,
                    
                    eventsTypes: [],
                    dailyDataType: currentPolicyCategory,
                    showDelta: false,
                    showPerCapita: false,
                    xAxisAsDaysSincePatientZero: false,
                    yAxesType: 'linear',
                    coronaData: coronaData,
                }}
            />
        </section>
    )
}